"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTitle = void 0;
const vue_1 = require("vue");
const CardType_1 = require("../../cards/CardType");
const CardCorporationLogo_1 = require("./CardCorporationLogo");
const i18n_1 = require("../../directives/i18n");
exports.CardTitle = vue_1.default.component('CardTitle', {
    props: {
        title: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
            validator: (card) => Object.values(CardType_1.CardType).includes(card),
        },
    },
    components: {
        CardCorporationLogo: CardCorporationLogo_1.CardCorporationLogo,
    },
    methods: {
        isCorporation: function () {
            return this.type === CardType_1.CardType.CORPORATION;
        },
        isPrelude: function () {
            return this.type === CardType_1.CardType.PRELUDE;
        },
        isLeader() {
            return this.type === CardType_1.CardType.LEADER;
        },
        getClasses: function (title) {
            const classes = ['card-title'];
            if (this.type === CardType_1.CardType.AUTOMATED) {
                classes.push('background-color-automated');
            }
            else if (this.type === CardType_1.CardType.ACTIVE) {
                classes.push('background-color-active');
            }
            else if (this.type === CardType_1.CardType.EVENT) {
                classes.push('background-color-events');
            }
            else if (this.type === CardType_1.CardType.PRELUDE) {
                classes.push('background-color-prelude');
            }
            else if (this.type === CardType_1.CardType.STANDARD_PROJECT || this.type === CardType_1.CardType.STANDARD_ACTION) {
                classes.push('background-color-standard-project');
            }
            else if (this.type === CardType_1.CardType.LEADER) {
                classes.push('background-color-leader');
            }
            const localeSpecificTitle = i18n_1.translateText(this.getCardTitleWithoutSuffix(title));
            if (localeSpecificTitle.length >= 31) {
                classes.push('title-xx-small');
            }
            else if (localeSpecificTitle.length >= 28) {
                classes.push('title-x-small');
            }
            else if (localeSpecificTitle.length > 26) {
                classes.push('title-smaller');
            }
            else if (localeSpecificTitle.length > 23) {
                classes.push('title-small');
            }
            return classes.join(' ');
        },
        getMainClasses() {
            const classes = ['card-title'];
            if (this.type === CardType_1.CardType.STANDARD_PROJECT || this.type === CardType_1.CardType.STANDARD_ACTION || this.type === CardType_1.CardType.TURMOIL_ACTION) {
                classes.push('card-title-standard-project');
            }
            return classes.join(' ');
        },
        getCardTitleWithoutSuffix(title) {
            return title.split(':')[0];
        },
    },
    template: `
      <div :class="getMainClasses()">
          <div v-if="isPrelude()" class="prelude-label">prelude</div>
          <div v-if="isLeader()" class="leader-label">leader</div>
          <div v-if="isCorporation()" class="corporation-label">corporation</div>
          <CardCorporationLogo v-if="isCorporation()" :title="title"/>
          <div v-else :class="getClasses(title)">{{ getCardTitleWithoutSuffix(title) }}</div>
      </div>
  `,
});
//# sourceMappingURL=CardTitle.js.map